class Logger {
	private storageKey = "form_logger"
	private isEnabled(): boolean {
		const flag = localStorage.getItem(this.storageKey)
		return flag === "true"
	}

	info(message: string, ...optionalParams: any[]) {
		if (this.isEnabled()) {
			console.log(`[INFO]: ${message}`, ...optionalParams)
		}
	}

	debug(message: string, ...optionalParams: any[]) {
		if (this.isEnabled()) {
			console.debug(`[DEBUG]: ${message}`, ...optionalParams)
		}
	}

	error(message: string, ...optionalParams: any[]) {
		if (this.isEnabled()) {
			console.error(`[ERROR]: ${message}`, ...optionalParams)
		}
	}

	warning(message: string, ...optionalParams: any[]) {
		if (this.isEnabled()) {
			console.warn(`[WARN]: ${message}`, ...optionalParams)
		}
	}
}

export const logger = new Logger()
